import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { QuestionnaireService } from '../services/questionnaire.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-mixture-row',
	templateUrl: './mixture-row.component.html',
	styleUrls: ['./mixture-row.component.scss']
})
export class MixtureRowComponent implements OnInit {
	@Input() public rowData: FormGroup;
	@Input() public displayErrors: boolean;
	@Input() public displayX: boolean = true;
	@Input() public index: number;
	@Output() public removed: EventEmitter<number> = new EventEmitter<number>();
	@Input() canDelete: boolean = true; 
	teurMaslulArray: string[] = [];
	maslulimJson: any;
	defaultValue = "";
	periodArray: string[] = [];
	ifSugRibit2Flag: boolean = false;

	constructor(
		private translate: TranslateService,
		private questionnaireService: QuestionnaireService
	) { }

	ngOnInit() {
		// this.rowData.get('ribit').setValidators([
		// 	Validators.required,
		// ]);
		this.questionnaireService.getMaslulim().subscribe(data => {
			const typeControl = this.rowData.get('type');
			const periodControl = this.rowData.get('period');
			const KodMaslul = typeControl.value.split("&");
			if (KodMaslul.length > 0 && Number(KodMaslul[0])) {
				const filteredArray = data.filter(item => item["KOD_MASLUL"] === Number(KodMaslul[0]));
				if (filteredArray.length > 0) {
					typeControl.setValue(filteredArray[0]['TEUR_MASLUL']);
				}
			}
			this.maslulimJson = data;
			this.teurMaslulArray = this.maslulimJson.map(item => item["TEUR_MASLUL"]);
			typeControl.valueChanges.subscribe(() => {
					this.rowData.get('ribit')!.clearValidators();
					this.rowData.get('ribit')!.setValue('99.99', { emitEvent: false });
					this.rowData.get('ribit')!.updateValueAndValidity({ emitEvent: false });				
					this.setValidation();
			});
			this.setValidation();
		});
		console.debug("MixtureRowComponent.ngOnInit()", this);
	}

	setValidation() {
		const typeControl = this.rowData.get('type');
		const filteredArray = this.maslulimJson.filter(item => item["TEUR_MASLUL"] === typeControl.value);
		if (filteredArray.length === 1) {
			this.rowData.get('ribit').clearValidators();
			if (filteredArray[0]['KOD_SUG_RBT'] === 3) {
				this.rowData.get('ribit').setValidators([
					Validators.required,
					Validators.pattern("^(?!-?$)\\-?(0|[1-9][0-9]*|[1-9][0-9]*\\.[0-9]{1,2})$"),
					Validators.min(-1.5),
					Validators.max(5)
				]);
			}
			else if (filteredArray[0]['KOD_SUG_RBT'] === 2) {
				this.rowData.get('ribit').setValidators([
					Validators.required,
					Validators.pattern("^(?!-?$)\\-?(0|[1-9][0-9]*|[1-9][0-9]*\\.[0-9]{1,2})$"),
					Validators.min(0),
					Validators.max(8)
				]);
			}
			else if (filteredArray[0]['KOD_SUG_RBT'] === 1) {
				this.rowData.get('ribit').setValidators([
					Validators.required,
					Validators.pattern("^(?!-?$)\\-?(0|[1-9][0-9]*|[1-9][0-9]*\\.[0-9]{1,2})$"),
					Validators.min(0),
					Validators.max(12)
				]);
			}

			if (filteredArray[0]['KOD_SUG_RBT'] === 2) {
				this.periodArray = []
				this.ifSugRibit2Flag = true;
				const MONE_MACHZOR_KLALI = filteredArray[0]['MONE_MACHZOR_KLALI'];
				let iteratorPeriodVar = MONE_MACHZOR_KLALI * 2;
				if (iteratorPeriodVar < 48) {
					iteratorPeriodVar = 48;
				}
				for (let i = 0; iteratorPeriodVar <= 360; i++) {
					this.periodArray[i] = iteratorPeriodVar.toString();
					iteratorPeriodVar = iteratorPeriodVar + MONE_MACHZOR_KLALI;
				}
			}			
			else {
				this.ifSugRibit2Flag = false;
			}
		}
		this.rowData.get('ribit')!.clearValidators();
		this.rowData.get('ribit')!.updateValueAndValidity({ emitEvent: false });
		this.rowData.get('period').setValidators([
			this.ifPeriodNotInArray()
		]);
	}

	ifPeriodNotInArray() {
		return (control: AbstractControl): { [key: string]: any } => {
			if(this.ifSugRibit2Flag){
				if(!this.periodArray.includes(this.rowData.get('period').value)){
					return { PeriodNotInArray: true };
				}
			}					
		}
	}


	ifValidForSugRibit(sugRibit) {
		const typeControl = this.rowData.get('type');
		const filteredArray = this.maslulimJson.filter(item => item["TEUR_MASLUL"] === typeControl.value);
		if (filteredArray[0]['KOD_SUG_RBT'] === sugRibit) {
			return true;
		}
		else {
			return false;
		}
	}

	titleTooltip(index) {
		return this.translate.instant('MIXTURE_ROW.TITLE_RIBIT') + (index + 1);
	}

	static buildItem(val: any) {
		return new FormGroup({
			type: new FormControl(val[0] ? val[0].answerValue : ""),
			amount: new FormControl(val[1] ? val[1].answerValue : ""),
			period: new FormControl(val[2] ? val[2].answerValue : ""),
			ribit: new FormControl('99.99')
		});

	}
}


// WEBPACK FOOTER //
// ./src/app/mixture-row/mixture-row.component.ts